export const searchReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "ADD_TO":
      console.log("reducer", payload);
      return { ...state, productsList: payload.products };

    case "REMOVE_FROM":
      return;

    case "INITIAL_USER_CART":
      console.log("reducer INITIAL_USER_CART", payload);
      return {  productsList: payload.products };

    case "SEARCH_VALUE":      
    // console.log("reducer search value001", payload);
    // console.log("reducer search value002", payload.searchTearm);
    // console.log("reducer search value003", state);
    // console.log("reducer search value004", state.searchTearm);
    // const thenewstate ={...state, searchTearm: payload.searchTearm};
    // console.log("reducer search value005", thenewstate);
    
      return {...state, searchTearm: payload.searchTearm}

    case "UPDATE_CART":
      return { ...state, productsList: payload.products };

    case "CLEAR_CART":
      return { ...state, productsList: [] };

    default:
      throw new Error("No Case Found In cartReducer");
  }
};
